import theme from 'theme'

export const DEFAULT_MENU_PROPS = {
  PaperProps: {
    sx: {
      backgroundColor: theme.colors.borderMedium,
      transform: `translateY(${theme.spacing.xSmall}px) !important`
    },
    style: {
      width: 322,
      maxHeight: 200,
      borderRadius: theme.spacing.md
    }
  },
  anchorOrigin: {
    vertical: 'bottom' as const,
    horizontal: 'left' as const
  },
  transformOrigin: {
    vertical: 'top' as const,
    horizontal: 'left' as const
  },
  variant: 'menu' as const
}
